import { Image } from "./image";
import { MakeImage, ImageProps } from "./types";

export const makeImage: MakeImage =
  ({
    src,
    width: defaultWidth,
    height: defaultHeight,
    dataTestId: defaultDataTestId,
  }) =>
  ({
    width = defaultWidth,
    height = defaultHeight,
    dataTestId = defaultDataTestId,
    ...restProps
  }: Omit<ImageProps, "src">) =>
    (
      <Image
        src={src}
        width={width}
        height={height}
        dataTestId={dataTestId}
        {...restProps}
      />
    );
